<template>
	<div class="faq">
		<v-col class="pt-5">
			<v-row class="text-center" v-if="!contentDetail">
				
			</v-row>
			<v-row v-else>
				<div v-if="Object.keys(contentDetail).length == 0">
					<v-container class="pa-0">
						<notfound></notfound>
					</v-container>
				</div>
				<div v-else>
					<v-col cols="12">
						<div class="text-h6 font-weight-bold text-capitalize">{{ contentDetail.content_title }}</div>
						<div class="py-2 d-flex text-body-2">
							<div class="grey--text text--darken-1">{{ contentDetail.content_datetime | tanggaljam }}</div>
							<div class="grey--text text--darken-1 pl-5" v-if="false">
								<v-icon small class="mt-n1" color="grey darken-1">mdi-eye</v-icon>
								<span class="pl-1">799</span>
							</div>
						</div>
					</v-col>
					<v-col cols="12" class="pt-0" v-if="false">
						<v-img width="100%" height="470" class="rounded-lg" src="https://i.pinimg.com/originals/94/a9/ef/94a9ef282f76a1f711049aed5c2de6c2.jpg"></v-img>
					</v-col>
					<v-col cols="12" class="pt-5">
						<div class="white-space-preline text-body-1">
							<div><span class="font-weight-bold"> </span> <span v-html="contentDetail.content_description"></span></div>
						</div>
					</v-col>
				</div>
			</v-row>
		</v-col>
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import notfound from '@/views/404.vue';

export default {
	components: {
		notfound
	},
	computed: {
		...mapState("content", ["contentDetail"]),
	},
	methods: {
		...mapActions("content", ["detailContent"]),
		...mapMutations("content", ["setDetailContent"]),
	},
	watch : {
		$route() {
			this.setDetailContent('')
			this.detailContent({
				slug: this.$route.params.slug
			}).then(() => {
				this.$store.dispatch('setPageTitle', this.contentDetail.content_category);
			})
		}
	},
	created() {
		this.detailContent({
			slug: this.$route.params.slug
		}).then(() => {
			this.$store.dispatch('setPageTitle', this.contentDetail.content_category);
		})
	}
};
</script>